import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from 'src/app/shared/services/rest.service';
import { ApiUrlConstants } from 'src/app/shared/constants/api-url.constants';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Injectable()
export class LessonCurriculumApiService extends RestService {
  constructor(injector: Injector) {
    super(injector);
  }

  getAllCurriculum(type?: string): Observable<any> {
    const url = type ? `${ApiUrlConstants.GET_ALL_CURRICULUM}?type=${type}` : ApiUrlConstants.GET_ALL_CURRICULUM;
    return this.get(url);
  }

  getCurriculum(id: number): Observable<any> {
    return this.get(
      UtilityService.replaceText(ApiUrlConstants.GET_CURRICULUM_DETAILS, [{ text: '@id', data: id }])
    );
  }
  
  getCurriculumByLessonPlan(id: number): Observable<any> {
    return this.get(
      UtilityService.replaceText(
        ApiUrlConstants.GET_CURRICULUM_BY_LESSON_PLAN,
        [{ text: '@id', data: id }]
      )
    );
  }

  createCurriculum(curriculum: any): Observable<any> {
    return this.post(ApiUrlConstants.CREATE_CURRICULUM, curriculum);
  }

  updateCurriculum(curriculum: any): Observable<any> {
    return this.post(ApiUrlConstants.UPDATE_CURRICULUM, curriculum);
  }

  deleteCurriculum(id: number): Observable<any> {
    return this.get(
      UtilityService.replaceText(ApiUrlConstants.DELETE_CURRICULUM, [{ text: '@id', data: id }])
    );
  }

  addLessonPlanToCurriculum(payload: { lesson_plan_id: number; curriculum_name: string }): Observable<any> {
    return this.post(ApiUrlConstants.ADD_LESSON_PLAN_TO_CURRICULUM, payload);
  }

  removeLessonPlanFromCurriculum(id: number): Observable<any> {
    return this.get(
      UtilityService.replaceText(ApiUrlConstants.REMOVE_LESSON_PLAN_FROM_CURRICULUM, [{ text: '@id', data: id }])
    );
  }
}
